import { ContractType } from '@received/pricing-model';
import { Contract } from '../ContractComponent/Contract';

export const EnterpriseContract = () => {
	return <Contract contractType={ContractType.ENTERPRISE} mainUrlToReturn='../customers' />;
};
